import { Box, Link, Typography, useTheme } from '@mui/material';
import { FooterSt } from './page-footer.styled';
import { FooterNav } from './nav-menu';

interface IProps {
  showNavMenu?: boolean;
}

export const PageSimpleFooter = ({ showNavMenu }: IProps) => {
  const version = process.env.REACT_APP_VERSION ?? '—';
  const theme = useTheme();

  return (
    <FooterSt id="index__components-page-simple-footer__footerst__l14">
      <Box id="index__components-page-simple-footer__box__l15"
      boxSizing={'border-box'}
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      py={'8px'}
      gap={'6px'}>
        
        {showNavMenu && <FooterNav />}

        <Typography id="index__components-page-simple-footer__typography__l26" variant="body1" align="center">
          Powered by{' '}
          <Link id="index__components-page-simple-footer__link__l28"
          href="https://www.trackgood.io/"
          target="_blank"
          rel="noopener noreferrer"
          color={theme.palette.primary.main}
          underline="hover"
          sx={{ fontWeight: 600 }}>
            
            Trackgood
          </Link>
        </Typography>

        <Typography id="index__components-page-simple-footer__typography__l40"
        variant="caption"
        align="center"
        color="text.secondary"
        sx={{ letterSpacing: 0.3 }}>
          
          version: {version}
        </Typography>
      </Box>
    </FooterSt>);

};